module.exports = __webpack_public_path__ + "f1cb0a1fe15083599cc728f3abca6358.png";